var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _linearGradient25, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFontSize(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5a5a5a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 84.312,
    x2: 178.78,
    xlinkHref: "#lg1",
    y1: 226.733,
    y2: 338.303
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#433f43",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a1a1a"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000182529611166522698630000016471766392106421171_",
    gradientUnits: "userSpaceOnUse",
    x1: 174.67,
    x2: 174.67,
    xlinkHref: "#lg2",
    y1: 365.302,
    y2: 459.489
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000147199721211228900520000006173395713132928701_",
    gradientUnits: "userSpaceOnUse",
    x1: 342.4,
    x2: 297.926,
    xlinkHref: "#lg2",
    y1: 445.435,
    y2: 426.599
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000129909735448139126840000006522173942185556627_",
    gradientUnits: "userSpaceOnUse",
    x1: 304.954,
    x2: 277.746,
    xlinkHref: "#lg2",
    y1: 389.469,
    y2: 335.751
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000124842803845609071220000014772217956390329261_",
    gradientUnits: "userSpaceOnUse",
    x1: 177.235,
    x2: 116.657,
    xlinkHref: "#lg2",
    y1: 359.112,
    y2: 359.112
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000056421092896789459340000009962127662440211083_",
    gradientUnits: "userSpaceOnUse",
    x1: 244.071,
    x2: 380.886,
    y1: 301.822,
    y2: 479.356
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a8d3d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7ca1b1"
  }))), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#596c76",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#596c76"
  }))), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000105407434039847982660000003200772415598363834_",
    gradientUnits: "userSpaceOnUse",
    x1: 300.432,
    x2: 362.325,
    xlinkHref: "#lg3",
    y1: 393.799,
    y2: 350.637
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000070094131156307652840000017229700058918913949_",
    gradientUnits: "userSpaceOnUse",
    x1: 319.727,
    x2: 319.727,
    xlinkHref: "#lg3",
    y1: 428.213,
    y2: 538.535
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000001644760888558241930000004637151480160099512_",
    gradientUnits: "userSpaceOnUse",
    x1: 211.962,
    x2: 227.31,
    xlinkHref: "#lg1",
    y1: -18.711,
    y2: 115.933
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000008853852179198726500000016496163219444382092_",
    gradientUnits: "userSpaceOnUse",
    x1: 134.484,
    x2: 149.832,
    xlinkHref: "#lg1",
    y1: -9.88,
    y2: 124.764
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000021838271296022334600000016953704048119572894_",
    gradientUnits: "userSpaceOnUse",
    x1: 57.007,
    x2: 72.355,
    xlinkHref: "#lg1",
    y1: -1.048,
    y2: 133.596
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000057108264142742920340000016893594175985730194_",
    gradientUnits: "userSpaceOnUse",
    x1: 366.917,
    x2: 382.265,
    xlinkHref: "#lg1",
    y1: -36.375,
    y2: 98.269
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000062149685818580794450000011540983075884966540_",
    gradientUnits: "userSpaceOnUse",
    x1: 289.439,
    x2: 304.787,
    xlinkHref: "#lg1",
    y1: -27.543,
    y2: 107.101
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000179604674336171090340000016923580226832022667_",
    gradientUnits: "userSpaceOnUse",
    x1: 409.409,
    x2: 424.757,
    xlinkHref: "#lg1",
    y1: -41.218,
    y2: 93.426
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000108996068880036863250000001755957307100496021_",
    gradientUnits: "userSpaceOnUse",
    x1: 14.514,
    x2: 29.862,
    xlinkHref: "#lg1",
    y1: 3.796,
    y2: 138.44
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000175280156160457635840000007422065473442921131_",
    gradientUnits: "userSpaceOnUse",
    x1: 386.674,
    x2: 514.342,
    xlinkHref: "#lg1",
    y1: 237.188,
    y2: 304.858
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000015313053113022607040000000437799036571306399_",
    gradientUnits: "userSpaceOnUse",
    x1: 354.198,
    x2: 481.866,
    xlinkHref: "#lg1",
    y1: 298.458,
    y2: 366.128
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000103962471818815163780000011619251289472458148_",
    gradientUnits: "userSpaceOnUse",
    x1: 321.722,
    x2: 449.389,
    xlinkHref: "#lg1",
    y1: 359.727,
    y2: 427.398
  })), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000151510547455860574110000017102348811089819550_",
    gradientUnits: "userSpaceOnUse",
    x1: 419.151,
    x2: 546.819,
    xlinkHref: "#lg1",
    y1: 175.918,
    y2: 243.589
  })), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000141421767838675278550000006455098532105365153_",
    gradientUnits: "userSpaceOnUse",
    x1: 451.627,
    x2: 579.295,
    xlinkHref: "#lg1",
    y1: 114.648,
    y2: 182.319
  })), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000094593264414631227400000008140069430911559559_",
    gradientUnits: "userSpaceOnUse",
    x1: 476.386,
    x2: 604.054,
    xlinkHref: "#lg1",
    y1: 67.938,
    y2: 135.609
  })), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000025424881764390545580000010972156979755283357_",
    gradientUnits: "userSpaceOnUse",
    x1: 296.963,
    x2: 424.631,
    xlinkHref: "#lg1",
    y1: 406.437,
    y2: 474.108
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m8.917 444.698c0-1.712.571-3.994 1.142-6.277l106.127-348.051c6.277-19.97 31.952-29.67 58.199-29.67 26.246 0 51.922 9.7 58.198 29.67l106.698 348.052c.571 2.283 1.141 4.565 1.141 6.277 0 21.111-32.523 36.517-57.057 36.517-14.264 0-25.676-4.565-29.099-16.547l-19.4-71.322h-120.392l-19.399 71.322c-3.424 11.982-14.835 16.547-29.099 16.547-24.536-.001-57.059-15.406-57.059-36.518zm207.12-119.821-41.652-152.915-41.652 152.915z",
    fill: "url(#SVGID_1_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m132.732 324.877h-88.052l-34.621 113.545c-.571 2.283-1.142 4.565-1.142 6.277 0 21.111 32.523 36.517 57.058 36.517 14.265 0 25.676-4.565 29.099-16.547l19.399-71.322h120.392l19.4 71.322c3.423 11.982 14.835 16.547 29.099 16.547 24.534 0 57.057-15.406 57.057-36.517 0-1.712-.57-3.994-1.141-6.277l-34.808-113.545h-88.436z",
    fill: "url(#SVGID_00000182529611166522698630000016471766392106421171_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m282.962 436.251c0 18.432 12.221 34.003 29.001 39.069 15.625-6.354 28.46-17.361 28.46-30.622 0-1.712-.57-3.994-1.141-6.277l-13.154-42.91c-.779-.044-1.563-.072-2.353-.072-22.541.001-40.813 18.273-40.813 40.812z",
    fill: "url(#SVGID_00000147199721211228900520000006173395713132928701_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m323.774 387.836-31.543-102.894-53.395 53.394 49.499 49.5z",
    fill: "url(#SVGID_00000129909735448139126840000006522173942185556627_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m132.732 324.877-18.258 68.47h120.391l-18.828-68.47z",
    fill: "url(#SVGID_00000124842803845609071220000014772217956390329261_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m312.075 267.096c-36.535 0-84.424 16.292-84.424 39.496 0 17.774 8.887 38.015 25.673 38.015 13.33 0 17.28-16.292 57.764-16.292 28.141 0 37.028 19.748 37.028 36.534v4.937h-17.774c-68.131 0-115.527 16.293-115.527 74.55 0 44.927 29.128 65.663 63.195 65.663 34.559 0 57.27-18.761 75.043-39.496v10.862c0 13.33 14.811 23.698 34.066 23.698 21.723 0 37.521-10.368 37.521-23.698v-117.502c0-49.864-31.598-96.767-112.565-96.767zm36.04 141.694c0 25.179-21.723 45.421-37.028 45.421-11.355 0-19.255-6.418-19.255-20.736 0-23.698 26.166-26.66 54.308-26.66h1.975z",
    fill: "url(#SVGID_00000056421092896789459340000009962127662440211083_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m293.375 443.075c-.995-2.685-1.542-5.868-1.542-9.599 0-23.698 26.166-26.66 54.308-26.66h1.975v-37.028h-17.774c-67.634 0-114.825 16.063-115.511 73.288h78.544z",
    fill: "url(#SVGID_00000105407434039847982660000003200772415598363834_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m348.115 406.815v1.975c0 25.179-21.723 45.421-37.028 45.421-11.355 0-19.255-6.418-19.255-20.736 0-23.698 26.166-26.66 54.308-26.66h-122.089c-5.995 9.95-9.237 22.301-9.237 37.522 0 44.927 29.128 65.663 63.195 65.663 34.559 0 57.27-18.761 75.043-39.496v10.862c0 13.33 14.811 23.698 34.066 23.698 21.723 0 37.521-10.368 37.521-23.698v-74.55h-76.524z",
    fill: "url(#SVGID_00000070094131156307652840000017229700058918913949_)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m232.475 15.697h-31.394c-4.335 0-7.848 3.514-7.848 7.848s3.514 7.848 7.848 7.848h31.394c4.335 0 7.848-3.514 7.848-7.848s-3.513-7.848-7.848-7.848z",
    fill: "url(#SVGID_00000001644760888558241930000004637151480160099512_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m153.991 15.697h-31.394c-4.335 0-7.848 3.514-7.848 7.848s3.514 7.848 7.848 7.848h31.394c4.335 0 7.848-3.514 7.848-7.848s-3.513-7.848-7.848-7.848z",
    fill: "url(#SVGID_00000008853852179198726500000016496163219444382092_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m75.507 15.697h-31.394c-4.335 0-7.848 3.514-7.848 7.848s3.514 7.848 7.848 7.848h31.394c4.335 0 7.848-3.514 7.848-7.848s-3.514-7.848-7.848-7.848z",
    fill: "url(#SVGID_00000021838271296022334600000016953704048119572894_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m389.444 15.697h-31.394c-4.335 0-7.848 3.514-7.848 7.848s3.514 7.848 7.848 7.848h31.394c4.335 0 7.848-3.514 7.848-7.848s-3.514-7.848-7.848-7.848z",
    fill: "url(#SVGID_00000057108264142742920340000016893594175985730194_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m310.959 15.697h-31.394c-4.335 0-7.848 3.514-7.848 7.848s3.514 7.848 7.848 7.848h31.394c4.335 0 7.848-3.514 7.848-7.848s-3.513-7.848-7.848-7.848z",
    fill: "url(#SVGID_00000062149685818580794450000011540983075884966540_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m416.791 0c-4.335 0-7.848 3.514-7.848 7.848v31.394c0 4.335 3.514 7.848 7.848 7.848s7.848-3.514 7.848-7.848v-31.394c.001-4.334-3.513-7.848-7.848-7.848z",
    fill: "url(#SVGID_00000179604674336171090340000016923580226832022667_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.766 0c-4.335 0-7.848 3.514-7.848 7.848v31.394c0 4.335 3.514 7.848 7.848 7.848s7.848-3.514 7.848-7.848v-31.394c0-4.334-3.514-7.848-7.848-7.848z",
    fill: "url(#SVGID_00000108996068880036863250000001755957307100496021_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m485.386 269.653c0-4.335-3.514-7.848-7.848-7.848-4.335 0-7.848 3.514-7.848 7.848v31.394c0 4.335 3.514 7.848 7.848 7.848 4.335 0 7.848-3.514 7.848-7.848z",
    fill: "url(#SVGID_00000175280156160457635840000007422065473442921131_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m485.386 348.137c0-4.335-3.514-7.848-7.848-7.848-4.335 0-7.848 3.514-7.848 7.848v31.394c0 4.335 3.514 7.848 7.848 7.848 4.335 0 7.848-3.514 7.848-7.848z",
    fill: "url(#SVGID_00000015313053113022607040000000437799036571306399_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m477.538 418.773c-4.335 0-7.848 3.514-7.848 7.848v31.394c0 4.335 3.514 7.848 7.848 7.848 4.335 0 7.848-3.514 7.848-7.848v-31.394c0-4.334-3.514-7.848-7.848-7.848z",
    fill: "url(#SVGID_00000103962471818815163780000011619251289472458148_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m485.386 191.169c0-4.335-3.514-7.848-7.848-7.848-4.335 0-7.848 3.514-7.848 7.848v31.394c0 4.335 3.514 7.848 7.848 7.848 4.335 0 7.848-3.514 7.848-7.848z",
    fill: "url(#SVGID_00000151510547455860574110000017102348811089819550_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m485.386 112.685c0-4.335-3.514-7.848-7.848-7.848-4.335 0-7.848 3.514-7.848 7.848v31.394c0 4.335 3.514 7.848 7.848 7.848 4.335 0 7.848-3.514 7.848-7.848z",
    fill: "url(#SVGID_00000141421767838675278550000006455098532105365153_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m461.841 76.397h31.394c4.335 0 7.848-3.514 7.848-7.848s-3.514-7.848-7.848-7.848h-31.394c-4.335 0-7.848 3.514-7.848 7.848s3.513 7.848 7.848 7.848z",
    fill: "url(#SVGID_00000094593264414631227400000008140069430911559559_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m493.234 494.303h-31.394c-4.335 0-7.848 3.514-7.848 7.848s3.514 7.848 7.848 7.848h31.394c4.335 0 7.848-3.514 7.848-7.848s-3.513-7.848-7.848-7.848z",
    fill: "url(#SVGID_00000025424881764390545580000010972156979755283357_)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFontSize);
export default __webpack_public_path__ + "static/media/font-size.9ea0479f132ea611709e58562898590c.svg";
export { ForwardRef as ReactComponent };